import {
  IPersistScrollPositionData,
  PersistScrollRepository
} from "../../repositories/persist/persist-scroll-repository";
import type {DebouncedFunc} from "lodash";
import debounce from "lodash/debounce"
import {isUndefined} from "../../util/is-type";

export class ScrollPositionPersist <ScrollElement extends HTMLElement = HTMLDivElement> {
  private readonly debouncedSaveScrollData: DebouncedFunc<(scrollData: IPersistScrollPositionData) => void>;
  constructor(private storageKey: string, private repository: PersistScrollRepository) {
    this.debouncedSaveScrollData = debounce(this.saveScrollData.bind(this), 100);
  }

  public restoreScrollPosition(element: ScrollElement): void {
    const scrollData = this.repository.getScrollData(this.storageKey);
    if (isUndefined(scrollData)) {
      // we don't have prior position data
      return;
    }

    if (window.innerWidth === scrollData.windowWidth){
      // window is same width, restore scroll position
      element.scrollTop = scrollData.scrollTop;
    } else {
      // window is different size, scroll position is not valid
      this.repository.removeScrollData(this.storageKey);
    }

  }

  private saveScrollData(scrollData: IPersistScrollPositionData){
    this.repository.saveScrollData(this.storageKey, scrollData);
  }

  private getScrollDataFromElement(element: ScrollElement): IPersistScrollPositionData {
    const scrollTop = element.scrollTop;
    const windowWidth = window.innerWidth;

    return {
      scrollTop,
      windowWidth
    };
  }

  private debouncedSaveCancel(): void {
    this.debouncedSaveScrollData.cancel();
  }

  public handleOnScroll(element: ScrollElement){

    // get new scroll data
    const scrollData = this.getScrollDataFromElement(element);

    this.debouncedSaveScrollData(scrollData);
  }

  public handleOnResize(element: ScrollElement){
    // cancel any pending debounced actions
    this.debouncedSaveCancel();

    // get new scroll data
    const scrollData = this.getScrollDataFromElement(element);

    // store new scroll data now
    this.saveScrollData(scrollData);
  }

  public handleOnDeviceOrientation(element: ScrollElement){
    // same handling as resize
    this.handleOnResize(element);
  }
}
